import { FC, useEffect, CSSProperties } from 'react';
import { mainButton } from '@telegram-apps/sdk-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useBackButtonToPrevRoute } from '@/hooks/useBackButtonToPrevRoute.tsx';
import { routes } from '@/navigation/routes.tsx';
import ConfettiShape from '@/components/common/svg/shapes/ConfettiShape.tsx';
import {
  containerStyles,
  contentHeaderStyles,
  contentMessageStyles,
  contentStyles
} from '@/components/Verification/styles.ts';

const WithdrawTonSuccess: FC = () => {
  useBackButtonToPrevRoute(routes.earnTon, false);

  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    mainButton.setParams({
      isVisible: true,
      backgroundColor: '#000000',
      text: t('earn.unlock_bonuses_popup.got_it')
    });

    const handleButtonClick = () => {
      mainButton.setParams({
        isVisible: false
      });

      navigate(routes.earnTon);
    };

    mainButton.onClick(handleButtonClick);

    return () => {
      mainButton.offClick(handleButtonClick);
      mainButton.setParams({
        isVisible: false
      });
    };
  }, []);

  return (
    <div style={containerStyles}>
      <div style={contentStyles}>
        <div style={circleStyle}>
          <ConfettiShape width={60} height={60} />
        </div>
        <span style={contentHeaderStyles}>
          {t('earn.withdraw.request_in_progress')}
        </span>
        <p style={contentMessageStyles}>
          {t('earn.withdraw.request_in_progress_details')}
        </p>
      </div>
    </div>
  );
};

const circleStyle: CSSProperties = {
  position: 'relative',
  zIndex: 2,
  width: '100px',
  height: '100px',
  borderRadius: '50%',
  marginBottom: 20,
  background: '#000000',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export default WithdrawTonSuccess;
